import 'prismjs';
import React, {useEffect, useState} from "react";
import Header from "./Header";
import "./App.css";
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import ConsoleOutput from "./ConsoleOutput";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Col from "react-bootstrap/Col";
import BondTree from "./BondTree";
import {
    faCode, faFileImport, faFolderTree, faMobileScreen, faScroll, faHeart, faMicrophone,

} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBluetoothB} from "@fortawesome/free-brands-svg-icons";
import CustomScripts from "./CustomScripts";
import TestApp from "./CustomApplications/TestApp";
import Sidebar from "./Sidebar";
import BackupRestore from "./CustomApplications/BackupRestore";
import Favorites from "./CustomApplications/Favorites";
import SetupBond from "./Sidebar/SetupBond";
import RxTx from "./CustomApplications/RxTx";
import MateDebug from "./CustomApplications/MateDebug";

function App() {
    const [messages, setMessages] = useState(null);
    const [bondId, setBondId] = useState(null);
    const [bondToken, setBondToken] = useState(null);
    const [bondApi, setBondApi] = useState(null);
    const [bondApiType, setBondApiType] = useState("cloud");
    const [currentTab, setCurrentTab] = useState("livelog");
    const [isSetupMode, setIsSetupMode] = useState(false);
    const [mateDebug, setMateDebug] = useState(false);


    function getHashPath() {
        if (window.location.hash) {
            if (window.location.hash.startsWith("#mate")) {
                setMateDebug(true);
                return;
            }

            let [_path, _bondToken] = window.location.hash.substring(1).split("|")
            if (_bondToken) setBondToken(_bondToken);
            window.location.hash = _path;

            // Handle new format: #/palantir/BONDID
            if (_path.startsWith("/palantir/")) {
                const _bondId = _path.substring("/palantir/".length).split("/")[0];
                setBondApiType("cloud");
                setBondId(_bondId);
                setCurrentTab("livelog");
                return;
            }

            // Handle legacy format: #cloud/livelog/BONDID or #local/tree/BONDID
            let [_apiType, _tab, _bondId] = _path.split("/")
            setBondApiType(_apiType);
            setBondId(_bondId);
            setCurrentTab(_tab);
        }
    }

    function clearBondId() {
        setBondId(null);
        setBondApi(null);
        setBondToken(null);
        localStorage.removeItem('apiType');
        localStorage.removeItem('bondId');
        localStorage.removeItem('currentTab');
        window.location.hash = '';
        setCurrentTab("livelog");
    }

    useEffect(() => {
        getHashPath();
    }, []);

    useEffect(() => {
        if (isSetupMode) return;

        if (bondApiType === "local" && !bondToken) {
            const savedToken = savedBondToken(bondId);
            if (savedToken) setBondToken(savedToken); else {
                setBondId(null);
                setBondApi(null);
            }
        }
        if (bondApiType && bondApi) bondApi.setApiType(bondApiType);
    }, [bondApiType, bondApi]);


    useEffect(() => {
        if (mateDebug) {
            window.location.hash = `#mate`;
        } else if (bondId && !isSetupMode) {
            window.location.hash = `${bondApiType}/${currentTab}/${bondId.toUpperCase()}`;
            localStorage.setItem('apiType', bondApiType);
            localStorage.setItem('bondId', bondId.toUpperCase());
            localStorage.setItem('currentTab', currentTab);
            document.title = `Bond Palantir | ${bondId.toUpperCase()}`;
        } else if (isSetupMode) {
            document.title = `Bond Palantir ${isSetupMode ? `| Setup ${bondId}` : ""}`;
        } else {
            // window.location.hash = ``;
        }
    }, [bondId, currentTab, bondApiType, isSetupMode, mateDebug]);

    useEffect(() => {
        if (bondApi && bondToken) {
            bondApi.bondToken = bondToken;
            savedBondToken(bondId, bondToken);
        }
    }, [bondApi, bondToken]);

    function savedBondToken(bondId, bondToken) {
        if (bondToken) {
            return localStorage.setItem(`bondToken-${bondId}`, bondToken);
        } else {
            return localStorage.getItem(`bondToken-${bondId}`);
        }
    }

    return (<div id="appRoot">
        <Header bondApiType={bondApiType} setBondApiType={setBondApiType} isSetupMode={isSetupMode}
                setMateDebug={() => {
                    setMateDebug(!mateDebug)
                }}/>
        <Container fluid>
            <Row className="appBody">
                {(!mateDebug) && <Col id="livelogRoot" className="col-12 col-lg-4 col-xl-3 pb-3 pt-2">
                    <Sidebar
                    setBondId={setBondId}
                    bondId={bondId}
                    clearBondId={clearBondId}
                    setBondApi={setBondApi}
                    bondApi={bondApi}
                    setMessages={setMessages}
                    setCurrentTab={setCurrentTab}
                    bondApiType={bondApiType}
                    bondToken={bondToken}
                    setBondToken={setBondToken}
                    isSetupMode={isSetupMode}
                    setIsSetupMode={setIsSetupMode}
                    setBondApiType={setBondApiType}
                />
                {isSetupMode && bondApi ? <Col className="col-12">
                    <SetupBond bondApi={bondApi} setIsSetupMode={setIsSetupMode}/>
                </Col> : ""}
            </Col>}

            {(bondApi && !mateDebug) ? <Col className="col-12 col-lg-8 col-xl-9 pb-3 pt-2">
                <Tabs
                    activeKey={currentTab}
                    className="appTabs mb-2"
                    onSelect={setCurrentTab}
                >
                    {!isSetupMode ? <Tab eventKey="livelog"
                                         title={<><FontAwesomeIcon icon={faScroll}
                                                                   className=''/> Livelog</>}>
                        <ConsoleOutput messages={messages} bondId={bondId} clearMessages={() => {
                            setMessages(null)
                        }}/>
                    </Tab> : ""}
                    <Tab eventKey="tree"
                         title={<><FontAwesomeIcon icon={faFolderTree} className=''/> API Tree</>}>
                        {bondApi ? <BondTree bond={bondApi}></BondTree> : <></>}
                    </Tab>
                    <Tab eventKey="test"
                         title={<><FontAwesomeIcon icon={faMobileScreen} className=''/> Test</>}>
                        {bondApi ? <TestApp bond={bondApi}></TestApp> : <></>}
                    </Tab>
                    <Tab eventKey="script"
                         title={<><FontAwesomeIcon icon={faCode} className=''/> Scripts</>}>
                        {bondApi ? <CustomScripts bond={bondApi}></CustomScripts> : <></>}
                    </Tab>
                    <Tab eventKey="backup"
                         title={<><FontAwesomeIcon icon={faFileImport} className=''/> Backup</>}>
                        {bondApi ? <BackupRestore bond={bondApi}></BackupRestore> : <></>}
                    </Tab>
                    <Tab eventKey="favorites"
                         title={<><FontAwesomeIcon icon={faHeart} className=''/> Favorites</>}>
                        {bondApi ? <Favorites bond={bondApi} currentTab={currentTab}></Favorites> : <></>}
                    </Tab>
                    <Tab eventKey="rxtx"
                         title={<><FontAwesomeIcon icon={faMicrophone} className=''/> Rx/Tx</>}>
                        {bondApi ? <RxTx bond={bondApi}></RxTx> : <></>}
                    </Tab>
                    <Tab eventKey="mate"
                         title={<><FontAwesomeIcon icon={faBluetoothB} className=''/> Mate</>}>
                        {bondApi ? <MateDebug bond={bondApi}></MateDebug> : <></>}
                    </Tab>
                </Tabs>
            </Col> : <></>}
                <div hidden={!mateDebug} className={"mateDebugRoot"}>
                    <MateDebug bond={null}></MateDebug>
                </div>
            </Row>
        </Container>
    </div>);
}

export default App;
